export default "__VITE_ASSET__2271e319__"